import { createContext, useContext, useState, useCallback, ReactNode } from 'react'
import { useCart } from '../hooks/useCart'
import type { Product, CartItem } from '../types'

interface CartContextValue {
  items: CartItem[]
  itemCount: number
  subtotal: number
  discount: number
  total: number
  isBundleEligible?: boolean
  addItem: (product: Product) => void
  removeItem: (productId: string) => void
  updateQuantity: (productId: string, quantity: number) => void
  clearCart: () => void
  // Estado de apertura del drawer del carrito, para poder abrirlo desde
  // cualquier parte (botón del header, "añadir al carrito", etc.).
  isCartOpen: boolean
  openCart: () => void
  closeCart: () => void
}

const CartContext = createContext<CartContextValue | null>(null)

export function CartProvider({ children }: { children: ReactNode }) {
  const cart = useCart()
  const [isCartOpen, setIsCartOpen] = useState(false)

  const openCart = useCallback(() => setIsCartOpen(true), [])
  const closeCart = useCallback(() => setIsCartOpen(false), [])

  return (
    <CartContext.Provider value={{ ...cart, isCartOpen, openCart, closeCart }}>
      {children}
    </CartContext.Provider>
  )
}

export function useCartContext() {
  const context = useContext(CartContext)

  if (!context) {
    throw new Error('useCartContext must be used within a CartProvider')
  }

  return context
}
